import { createContext, useContext, useState, type ReactNode } from 'react'

interface HeaderContextValue {
  dynamicTitle: string | undefined
  setDynamicTitle: (title: string | undefined) => void
}

const HeaderContext = createContext<HeaderContextValue | undefined>(undefined)

export function HeaderProvider({ children }: { children: ReactNode }) {
  const [dynamicTitle, setDynamicTitle] = useState<string | undefined>(undefined)

  return (
    <HeaderContext.Provider value={{ dynamicTitle, setDynamicTitle }}>
      {children}
    </HeaderContext.Provider>
  )
}

export function useHeaderContext() {
  const context = useContext(HeaderContext)
  if (!context) {
    throw new Error('useHeaderContext must be used within HeaderProvider')
  }
  return context
}
